// Local storage related keys
export const LOCAL_STORAGE_KEYS = {
  USER: 'df_user',
  ACCESS_TOKEN: 'df_auth_token',
  TOKEN_DATA: 'df_token_data',
  SELECTED_TENANT: 'df_selected_tenant',
} as const;
